<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report Annual Budget vs Realization (MONTHLY vs YTD)
                <div class="card-header-actions">
                    <button class="btn btn-primary mr-1" @click="exportxls()">
                        <i class="fa fa-file-excel-o"></i>
                        Export
                    </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="6" xl="4">
                  <b-input-group >
                        <b-input-group-prepend><label>Date Range</label></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" readonly></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4" xl="3">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row >
            <b-row >
                <b-col lg="10" xl="8">
                  <b-input-group >
                        <b-input-group-prepend><label>Dept/Div/Dir</label></b-input-group-prepend>
                        <b-form-radio-group  class="mt-2" v-model="filter.opsiDept" name="radioDept" :state="!$v.filter.opsiDept.$error">
                            <b-form-radio value="1">All</b-form-radio>
                            <b-form-radio value="2">Empty (Non Dept)</b-form-radio>
                            <b-form-radio value="3">Choice</b-form-radio>
                        </b-form-radio-group>
                        <b-form-select v-model="filter.DimCol" :state="!$v.filter.DimCol.$error" :plain="true" :options="['Department','Division','Directorat']" :disabled="(filter.opsiDept!=3)"></b-form-select>
                        <b-form-input v-model="filter.departemen" :state="!$v.filter.departkd.$error" placeholder="Value" class="ml-1" disabled style="width:27%"></b-form-input>
                        <b-input-group-append v-if="(filter.opsiDept==3)">
                            <b-btn text="Button" @click="lkuDeptShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col lg="2" xl="1">
                    <b-button class="btn btn-success" @click="process()" > <i class="fa fa-play"></i> Process</b-button>
                </b-col>
            </b-row >
            <b-card no-body>
                <div class="report-wraper">
                    <table width='100%'>
                        <thead>
                            <tr>
                                <th rowspan="2">Description</th>
                                <th colspan="3" style="text-align:center;" >{{filter.bulan}} {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;">Year To Date</th>
                                <th colspan="3" style="text-align:center;">TOTAL</th>
                            </tr>
                            <tr>
                                <th style="text-align:center" width="100px">Budget</th>
                                <th style="text-align:center" width="100px">Actual</th>
                                <th style="text-align:center" width="100px">Variant </th>
                                <th style="text-align:center" width="100px">Budget</th>
                                <th style="text-align:center" width="100px">Actual</th>
                                <th style="text-align:center" width="100px">Variant </th>
                                <th style="text-align:center" width="100px">Budget</th>
                                <th style="text-align:center" width="100px">Actual</th>
                                <th style="text-align:center" width="100px">Variant </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptLines" :key="row.idrowunik">
                                <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.monB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    <!-- <span v-if="row.kode || row.rumus">{{row.mon | numFormat}}</span> -->
                                    <b-link v-if="row.kode || row.rumus" @click="drillCurrentMonth(row)">{{row.mon | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.monV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.ytdB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonToDate(row)">{{row.ytd | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.ytdV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.totalB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.total | numFormat}}</span>
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.totalV | numFormat}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="lkuDeptShow" size="lg" :hide-footer="true" title="List of Department" :centered="true">
            <lku-department @click="onSelectLkuDept"></lku-department>
        </b-modal>        
    </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuDepartment from "../lookup/lkuDepartment";
import budget_dept from "../../apis/budget_dept";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required,requiredIf } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        opsiDept: { required },
        DimCol: { required },
        departkd: {
                required: requiredIf(function () {
                    return this.filter.opsiDept==3
                })
            },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      monthLabels: dropdown.monthLabels,
      filter: {layout:'', opsiDept:3, DimCol:'Department', departkd:'',tahun:moment(this.$store.state.user.tglaktif).format('YYYY'), bulan:moment(this.$store.state.user.tglaktif).format('MMM')},
      model: {copysrc:0,markup:0,tahunsrc:parseInt(this.$store.state.user.tglaktif.substring(0,4))},
      lkuDeptShow:false,
      isLoading: false,
      layouts:[],
      horizontal: true,
      reportUrl: null,
      showReport:false,
      rptLines:[]
    };
  },
components: { lkuDepartment,Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
      layout: async function(newval) {
          this.rptLines= await budget_dept.layout({layout : newval});
      }
  },
created: async function (){
     this.layouts = await budget_dept.layout_combo();
    var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');

     let bln = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').month();
     let awal= parseInt(this.$store.state.user.awalbln || '1')-1;
     if ((bln-awal) > 10) {
         this.enableNextYear=true;
     }
  },
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        this.filter.tahun=tgl1.format('YYYY');
        this.filter.bulan=tgl2.format('MMM');
        this.filter.bln=tgl2.month();
    },
    onSelectLkuDept: async function (_selected) {
        this.lkuDeptShow=false;
        if (this.filter.DimCol=='Department') {
            this.filter.departemen = _selected.departkd.trim() + ' | ' + _selected.departemen.trim();
            this.filter.departid = _selected.departid;
            this.filter.departkd = _selected.departkd;
        } else  if (this.filter.DimCol=='Division') {
            this.filter.departemen = _selected.division;
            this.filter.departid = _selected.division;
            this.filter.departkd = _selected.division;
        } else {
            this.filter.departemen = _selected.directorate;
            this.filter.departid = _selected.directorate;
            this.filter.departkd = _selected.directorate;
        }
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
                this.filter.bln = moment(this.filter.tgl2, 'YYYY-MM-DD').month();

                this.rptLines= await budget_dept.actualv2(this.filter);
                // console.log('bln : ', this.filter.bln);
                this.rptLines.forEach((row, idx) => {
                        switch (this.filter.bln) {
                            case 0:
                                this.rptLines[idx].monB = row.janB;
                                this.rptLines[idx].mon = row.jan;
                                this.rptLines[idx].monV = row.janB-row.jan;

                                break;
                            case 1:
                                this.rptLines[idx].monB = row.febB;
                                this.rptLines[idx].mon = row.feb;
                                this.rptLines[idx].monV = row.febB-row.feb;

                                break;
                            case 2:
                                this.rptLines[idx].monB = row.marB;
                                this.rptLines[idx].mon = row.mar;
                                this.rptLines[idx].monV = row.marB-row.mar;

                                break;
                            case 3:
                                this.rptLines[idx].monB = row.aprB;
                                this.rptLines[idx].mon = row.apr;
                                this.rptLines[idx].monV = row.aprB-row.apr;

                                break;
                            case 4:
                                this.rptLines[idx].monB = row.meiB;
                                this.rptLines[idx].mon = row.mei;
                                this.rptLines[idx].monV = row.meiB-row.mei;

                                break;
                            case 5:
                                this.rptLines[idx].monB = row.junB;
                                this.rptLines[idx].mon = row.jun;
                                this.rptLines[idx].monV = row.junB-row.jun;

                                break;
                            case 6:
                                this.rptLines[idx].monB = row.julB;
                                this.rptLines[idx].mon = row.jul;
                                this.rptLines[idx].monV = row.julB-row.jul;

                                break;
                            case 7:
                                this.rptLines[idx].monB = row.agtB;
                                this.rptLines[idx].mon = row.agt;
                                this.rptLines[idx].monV = row.agtB-row.agt;

                                break;
                            case 8:
                                this.rptLines[idx].monB = row.sepB;
                                this.rptLines[idx].mon = row.sep;
                                this.rptLines[idx].monV = row.sepB-row.sep;

                                break;
                            case 9:
                                this.rptLines[idx].monB = row.oktB;
                                this.rptLines[idx].mon = row.okt;
                                this.rptLines[idx].monV = row.oktB-row.okt;

                                break;
                            case 10:
                                this.rptLines[idx].monB = row.novB;
                                this.rptLines[idx].mon = row.nov;
                                this.rptLines[idx].monV = row.novB-row.nov;

                                break;
                            case 11:
                                this.rptLines[idx].monB = row.desB;
                                this.rptLines[idx].mon = row.des;
                                this.rptLines[idx].monV = row.desB-row.des;

                                break;
                        }

                        this.rptLines[idx].ytdV = row.ytdB-row.ytd;
                        this.rptLines[idx].totalV = row.totalB-row.total;
                });
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                await budget_dept.actualv2ytdexport(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
       }
    },
    drillCurrentMonth: function(data)
    {
        if (data.kode) {
        //     var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        //     let routeData = router.resolve({path: `ledger/${data.kode}/${tgl2.format('YYYY-MM')}-01/${this.filter.tgl2}`});
        //     window.open(routeData.href, '_blank');
        // }
        // if ((data.kode) && (data.mon)) {
                this.$bvModal.msgBoxConfirm(`Detail value of ${data.uraianfmt.toUpperCase() }, current month ${moment(this.filter.tgl2).format('MMM YYYY').toUpperCase() } ?`, {
                title: 'Drilldown Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
                })
                .then(value => {
                    if (value==true) {
                        // var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                        // let routeData = router.resolve({path: `ledger/${data.kode}/${tgl2.format('YYYY-MM')}-01/${this.filter.tgl2}`});
                        const tgl1= `${moment(this.filter.tgl2).format('YYYY-MM')}-01`;
                        const tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');

                        const routeData = router.resolve({path: `ledger/${data.kode}/${tgl1}/${tgl2}/${data.uraian}/${this.filter.departkd || '-'}/${this.filter.departemen || '-'}/${this.filter.opsiDept}/${this.filter.DimCol}`});
                        window.open(routeData.href, '_blank');
                    }
                })
                .catch(err => {
                    console.log('msgBoxConfirm error', err);
                })
        }
    },
    drillMonToDate: function(data)
    {
        if ((data.kode) && (data.ytd)) {
                this.$bvModal.msgBoxConfirm(`Detail value of ${data.uraianfmt.toUpperCase() }, as of ${moment(this.filter.tgl2).format('MMM YYYY').toUpperCase() } ?`, {
                title: 'Drilldown Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
                })
                .then(value => {
                    if (value==true) {
                        // let routeData = router.resolve({path: `ledger/${data.kode}/${this.filter.tgl1}/${this.filter.tgl2}`});
                        const tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                        const tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                        const routeData = router.resolve({path: `ledger/${data.kode}/${tgl1}/${tgl2}/${data.uraian}/${this.filter.departkd || '-'}/${this.filter.departemen || '-'}/${this.filter.opsiDept}/${this.filter.DimCol}`});
                        window.open(routeData.href, '_blank');
                    }
                })
                .catch(err => {
                    console.log('msgBoxConfirm error', err);
                })

        }
    },
    close(){
      router.push("home");
    }
  }
};
</script>
